<template>
  <div class="lp-child-base basic-input" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-input
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :action="action"
      :method="method"
      :token="token"
      :lp-id="lpId"
      pageLabel="basicinput"
    />
  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneInput from './blocks/BlockFortuneInput'
export default {
  name: 'BasicInput',
  components: {
    BlockTitle,
    BlockFortuneInput
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    token: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post',
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.color-test{
  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #ddd;
    margin-right: 2px;
    &.key-color {
      background: $l_col_keycolor;
    }
    &.second {
      background: $l_col_second;
    }
    &.grad-start {
      background: $l_col_grad_start;
    }
    &.grad-end {
      background: $l_col_grad_end;
    }
    &.gradiation {
      width: 100px;
      background: linear-gradient(86.51deg, $l_col_grad_start 21.4%, $l_col_grad_end 76.64%);
    }
  }
}
.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .block-title,
  .block-fortune-input {
    background: #FFECEB;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/BasicInput.vue